import { Link } from "react-router-dom";
import { categories } from "@/mocks/news";

const accents: Record<string, string> = {
  society: "bg-primary-100 text-primary-700",
  entertainment: "bg-accent-100 text-accent-700",
  tech: "bg-secondary-100 text-secondary-700",
};

export default function CategoryEntry() {
  return (
    <section className="max-w-7xl mx-auto w-full px-4 md:px-6 py-10 md:py-14">
      <div className="flex items-end justify-between mb-6">
        <div>
          <h2 className="text-xl md:text-2xl font-heading font-black text-foreground-950">
            分类快捷入口
          </h2>
          <p className="text-sm text-foreground-500 mt-1">
            三大主频道，直达你最关心的爆料现场
          </p>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {categories.map((c) => (
          <Link
            key={c.slug}
            to={`/category/${c.slug}`}
            className="group bg-background-50 border border-background-200 rounded-lg p-5 hover:border-primary-300 transition-colors cursor-pointer"
          >
            <div
              className={`w-12 h-12 flex items-center justify-center rounded-lg text-2xl ${accents[c.slug]}`}
            >
              <i className={c.icon} />
            </div>
            <h3 className="mt-4 text-lg font-heading font-bold text-foreground-950 group-hover:text-primary-600 transition-colors">
              {c.name}爆料
            </h3>
            <p className="mt-2 text-sm text-foreground-600 leading-relaxed line-clamp-2">
              {c.intro}
            </p>
            <div className="mt-4 flex flex-wrap gap-2">
              {c.subs.map((s) => (
                <span
                  key={s}
                  className="text-xs px-2 py-0.5 rounded-full bg-background-100 text-foreground-600"
                >
                  {s}
                </span>
              ))}
            </div>
            <span className="mt-4 inline-flex items-center gap-1 text-sm text-primary-600">
              进入频道
              <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}